import { ValidationErrorResponseSchema } from '@mntn/api-contracts/_shared/error-responses'
import { ErrorResponseSchema } from '@mntn/result'
import { initContract } from '@ts-rest/core'
import {
  DeleteProgramBodySchema,
  DeleteProgramRequestSchema,
  DeleteProgramResponseSchema,
  GetProgramsQuerySchema,
  GetProgramsRequestSchema,
  GetProgramsResponseSchema,
  PatchProgramsBodySchema,
  PatchProgramsRequestSchema,
  PatchProgramsResponseSchema,
  PostProgramsBodySchema,
  PostProgramsRequestSchema,
  PostProgramsResponseSchema,
} from './schemas.ts'

const c = initContract()

const BASE = '/seller/v1/programs'

export const programsContract = c.router(
  {
    list: c.query({
      method: 'GET',
      path: BASE,
      description: 'Get paginated programs',
      query: GetProgramsQuerySchema,
      request: GetProgramsRequestSchema,
      responses: {
        200: GetProgramsResponseSchema,
        500: ErrorResponseSchema,
      },
    }),
    create: c.mutation({
      method: 'POST',
      path: BASE,
      description: 'Create a program',
      body: PostProgramsBodySchema,
      request: PostProgramsRequestSchema,
      responses: {
        200: PostProgramsResponseSchema,
        404: ErrorResponseSchema,
        500: ErrorResponseSchema,
      },
    }),
    update: c.mutation({
      method: 'PATCH',
      path: BASE,
      description: 'Update a program',
      body: PatchProgramsBodySchema,
      request: PatchProgramsRequestSchema,
      responses: {
        200: PatchProgramsResponseSchema,
        404: ErrorResponseSchema,
        500: ErrorResponseSchema,
      },
    }),
    delete: c.mutation({
      method: 'DELETE',
      path: BASE,
      description: 'Delete a program',
      body: DeleteProgramBodySchema,
      request: DeleteProgramRequestSchema,
      responses: {
        200: DeleteProgramResponseSchema,
        404: ErrorResponseSchema,
        409: ErrorResponseSchema,
        500: ErrorResponseSchema,
      },
    }),
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      400: ValidationErrorResponseSchema,
      403: ErrorResponseSchema,
    },
    metadata: { tags: ['Programs'] },
  },
)

export type ProgramsContract = typeof programsContract
